<template>
  <div>
    <!-- <div class="waringTips">
      <img src="../assets/tit.png">
      <div>
        <span  class="txt">
          尊敬的用户 ：即日起，所有交易订单均需在72小时内完成发货。若超时未发货系统将触发自动退款，退款金额原路返还给买家。
        </span>
        <a target="_blank" href="https://www.165183.com/V2016/NewsShowMsg.aspx?NewsId=103088" style="color:black;">
           请点击了解详情>
        </a>
      </div>
    </div> -->
    <el-container>
      <el-aside>
        <side-menu />
      </el-aside>
      <el-container>
        <el-header>
          <Head />
        </el-header>
        <el-main>
          <slot></slot>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Head from "@/layouts/components/Head.vue";
import SideMenu from "./components/SideMenu.vue";

export default {
  name: "LayoutView",
  components: { Head, SideMenu },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.waringTips {
  background-image: url("../assets/tipsBg.png");
  background-size: cover;
  padding: 10px;
  display: flex;
  align-items: center;
  .txt {
    color: #db0000;
    margin-left: 20px;
  }
}

.el-main {
  padding: 0;
  font-size: 14px;
}
.el-header {
  border-bottom: 1px solid #cecece;
  z-index: 1;
  height: 50px !important;
  .head {
    display: flex;
    display: -webkit-flex;
    height: 50px;
    align-items: center;
  }
}
.el-aside {
  height: 100vh;
  width: 200px !important;
  background-color: #304156;
  z-index: 9999;
}
</style>
